const credits = `
<div class="credits">
<p>An adventure by Romain Baudry.</p>

<p>Early version of the adventure written in French for the <a target="_blank" rel="noopener noreferrer" href="http://litteraction.fr/presentation/livre-dont-on-est-le-heros/resultats-detailles-du-concours-yaztromo-2011">Yaztromo 2011</a>.</p>

<p>Scenario, original text, translation and map by Romain Baudry.</p>

<p>Illustrations by <a target="_blank" rel="noopener noreferrer" href="http://klauspillon.deviantart.com/">Klaus Pillon</a>, initially for the <em>Gamebook Store</em> project.</p>

<p>Other graphical elements by <a target="_blank" rel="noopener noreferrer" href="https://lemmasoft.renai.us/forums/viewtopic.php?t=40027">WinterMochie</a>.</p>

<p>Coding by <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/Skarn_TG">Skarn</a>.</p>
</div>
`;

export default credits;



// WEBPACK FOOTER //
// ./src/scripts/credits.js